<template>
  <div id="registration">
    <v-card>
      <h2>{{ $t("registration") }}</h2>
      <div id="login-message" v-if="serverErrors.length > 0">
        <div v-for="(error, index) in serverErrors" :key="index">
          {{ error.message }}
        </div>
      </div>
      <v-form
        ref="form"
        v-model="isRegistrationFormValid"
        @submit.prevent="onSubmit"
      >
        <v-text-field
          v-model="doctor.user.email"
          :rules="[rules.required, rules.email]"
          outlined
          dense
          label="Email"
        />
        <v-text-field
          v-model="doctor.password"
          :rules="[rules.required, rules.minLength]"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          class="my-1"
          outlined
          dense
          label="Heslo"
          @click:append="showPassword = !showPassword"
        />
        <v-text-field
          v-model="confirmPassword"
          :rules="[
            rules.required,
            rules.minLength,
            rules.sameAs(confirmPassword, doctor.password)
          ]"
          :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showConfirmPassword ? 'text' : 'password'"
          class="my-1"
          outlined
          dense
          :label="$t('confirm_password')"
          @click:append="showConfirmPassword = !showConfirmPassword"
        />
        <v-btn class="registration-btn" type="submit">{{
          $t("registrate")
        }}</v-btn>
      </v-form>
      <div class="login-link">
        {{ $t("already_have_acount") }}
        <router-link to="prihlaseni">{{ $t("login_text") }}</router-link>
      </div>
    </v-card>
    <v-dialog v-model="showDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{
          $t("confirmation_email_title")
        }}</v-card-title>
        <v-card-text>
          <p>
            {{ $t("confirmation_email_text") }}
          </p>
          <p>{{ $t("confirmation_email_text1") }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#324c8d" text @click="showDialog = false">{{
            $t("close")
          }}</v-btn>
          <v-btn
            color="#324c8d"
            text
            @click="$router.push({ name: 'prihlaseni' })"
          >
            {{ $t("login_text") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      doctor: {
        user: { email: "" },
        password: ""
      },
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      showDialog: false,
      serverErrors: [],
      isRegistrationFormValid: true,
      rules: {
        required: value => !!value || this.$t("validate_required"),
        minLength: value =>
          value.length >= 6 || this.$t("validate_pass_length"),
        sameAs: (value, password) =>
          value === password || this.$t("validate_pass_same"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("validate_email");
        }
      }
    };
  },
  methods: {
    async registerUser() {
      try {
        await this.$http.post("doctors", this.doctor);
        this.showDialog = true;
      } catch (error) {
        if (error.status >= 500) {
          // eslint-disable-next-line no-console
          console.error("Server error");
        } else {
          this.serverErrors = error.data.errors;
        }
      }
    },
    onSubmit() {
      this.$refs.form.validate();
      if (this.isRegistrationFormValid) {
        this.registerUser();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#registration {
  .login-link {
    max-width: 25rem;
    margin: 3rem auto 0 auto;
    text-align: center;
  }

  .v-form {
    margin-top: 2rem;
  }

  #login-message {
    margin-top: 1rem;
    padding: 1rem 0.7rem;
    font-size: 0.9rem;
    background: rgb(253, 192, 192);
  }

  .v-card {
    padding: 2rem;
    max-width: 25rem;
    margin: auto;
    box-shadow: 0px 0px 18px 0px #d1d1d1;
  }

  .registration-btn {
    width: 100%;
    background: #324c8d;
    color: white;
  }

  @media only screen and (max-width: 500px) {
    padding: 16px 5px;
  }
}
</style>
